import { emptyGame } from 'src/providers/Games/useGames';
import { IContent } from './featured';

export const GamesFeaturing: IContent[] = [
	{
		game: {
			...emptyGame,
			name: 'Lumencraft',
			creator: '2Dynamic Games',
			media: {
				coverImageUrl: 'https://cdn.hashup.it/games/lumencraft/cover.png',
				logoUrl: '',
				banner: 'https://cdn.hashup.it/games/lumencraft/banner.png',
			},
			platforms: ['pc'],
			price: '120000',
			color: 'gray',
			address: '0x9b670efbe409834fa631588b0c75df403ec4333e',
			description:
				'Desperate, outnumbered and with gun turrets as your only companion. Lumencraft is a top-down shooter with base-building elements.',
		},
	},
	{
		game: {
			...emptyGame,
			name: 'Portal Car',
			creator: 'White Dog Games',
			media: {
				coverImageUrl: 'https://live.staticflickr.com/65535/52200814860_509084357c_b.jpg',
				logoUrl: '',
				banner: 'https://live.staticflickr.com/65535/52199317182_f2d3685562_b.jpg',
			},
			platforms: ['pc'],
			price: '20000',
			color: 'gold',
			address: '0xc41a20cfb81b34b5f3d4cfce5d889f1a16bb0a8d',
			description:
				'Portal car is a puzzle game. use the mouse to move portals and help drivers to park their cars in the right place. includes: *50+ different levels *Eye-popping visual *Funny mechanic',
		},
	},
	{
		game: {
			...emptyGame,
			name: 'Jumping Knight',
			creator: 'White Dog Games',
			media: {
				coverImageUrl: 'https://live.staticflickr.com/65535/52176470373_3bbfba5093_b.jpg',
				logoUrl: '',
				banner: 'https://live.staticflickr.com/65535/52168112309_6c6da642be_b.jpg',
			},
			platforms: ['pc'],
			price: '50000',
			color: 'gold',
			address: '0xe90265a92643eb69339734c52bf1cb531569efd9',
			description:
				'Jumping Knight is a platformer game with an atmospheric-dark world and a lot of challenging levels. The story is simple, the main character is a tiny knight who lost his princess, who was kidnapped by a strange monster. Your main task is to find her and protect her from this monster.',
		},
	},
	{
		game: {
			...emptyGame,
			name: 'Crypto Wars',
			creator: 'WTGame Studios',
			media: {
				coverImageUrl: 'https://live.staticflickr.com/65535/52163960307_57ad029755_h.jpg',
				logoUrl: '',
				banner: 'https://live.staticflickr.com/65535/52169581423_2484ceb571.jpg',
			},
			platforms: ['pc'],
			price: '500000',
			color: 'custom',
			address: '0xd037102c5bc71e576fe9c0b1b8398e58be1e4ef7',
			description:
				'Start your adventure in a magic Cryptoland that needs saving from evil forces that all want to use crypto for bad purposes.',
		},
		discount: '1000000',
	},
];
